export default __webpack_public_path__ + "images/052ad3b4703d7d106342ca861d8a1c4c.svg";